import React from 'react';

export default function SuccessScreen({ result, onReset }) {
  return (
    <div className="wizard-container">
      <div className="success-screen">
        <div className="success-icon"><i className="bi bi-check-circle-fill"></i></div>
        <h2>Application Submitted!</h2>
        <p>Thank you for applying. We will get back to you soon.</p>
        {result?.application_id && (
          <p style={{ marginTop: 10, fontWeight: 500 }}>
            Application ID: <strong>{result.application_id}</strong>
          </p>
        )}
        <button className="btn btn-primary" style={{ marginTop: 20 }} onClick={onReset}>
          Submit Another Application
        </button>
      </div>
    </div>
  );
}
